export default "__VITE_ASSET__7f1dbdc8__"